import { PrestationModel } from './models/prestation.model';
import { PrestationApiModel } from './models/api/prestation.apimodel';

export class ReportingProjector {
    public static projectPrestations(prestations: PrestationApiModel[]): PrestationModel[] {
        return prestations.map(p => {
            return <PrestationModel>p;
        });
    }
}